import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from '../../config/services/config.service';
import { SplashScreenStateService } from '../../common/services/splash-screen-state.service';
import { LoggingService } from '../../logging/logging.service';

/**
 * Route guard for the ArrivalBoard feature. Gated by the backend feature flag
 * `features.arrivalBoard.enabled` of the instance configuration — the same flag the config
 * editor writes — not by a white-label build config. Mirrors the other feature guards
 * (e.g. ShopFeatureGuard).
 */
export const arrivalBoardFeatureGuard = () => {
    const router = inject(Router);
    const configService = inject(ConfigService);
    const splashScreenStateService = inject(SplashScreenStateService);
    const log = inject(LoggingService).getLogger('arrivalBoardFeatureGuard');

    if (configService.config()?.configuration?.features?.arrivalBoard?.enabled) {
        splashScreenStateService.stop();
        return true;
    }
    log.info("Feature arrivalBoard isn't enabled");
    return router.navigate(['/']);
};
